












































import { Component, Vue } from 'vue-property-decorator';
import Bowser from 'bowser';
import Cookies from 'js-cookie';

declare const window: any;

@Component
export default class SmartBanner extends Vue {
  private cookieName = 'smartbanner-closed';
  private cookieExpirationDays = 30;
  private isVisible = true;

  mounted() {
    // Add body padding when banner is visible
    if (this.shouldShowBanner) {
      document.body.style.paddingTop = '84px';

      // Adjust for smaller screens
      const mediaQuery = window.matchMedia('(max-width: 480px)');
      const updatePadding = () => {
        document.body.style.paddingTop = mediaQuery.matches ? '74px' : '84px';
      };

      mediaQuery.addEventListener('change', updatePadding);
      updatePadding();

      // Clean up on destroy
      this.$once('hook:beforeDestroy', () => {
        mediaQuery.removeEventListener('change', updatePadding);
      });
    }
  }

  beforeDestroy() {
    // Remove body padding when component is destroyed
    document.body.style.paddingTop = '';
  }

  get browserParser() {
    return Bowser.getParser(window.navigator.userAgent);
  }

  get shouldShowBanner(): boolean {
    // Don't show if cookie exists or isVisible is false
    if (Cookies.get(this.cookieName) || !this.isVisible) {
      return false;
    }

    // Only show on mobile devices
    const platform = this.browserParser.getPlatform();

    return platform.type === 'mobile' || platform.type === 'tablet';
  }

  get appIcon(): string {
    return 'https://cdn.planbook.com/images/planbook-icon.png';
  }

  get appTitle(): string {
    return this.$t('common.smartBanner.title') as string;
  }

  get appAuthor(): string {
    return this.$t('common.smartBanner.author') as string;
  }

  get appPrice(): string {
    return this.$t('common.smartBanner.price') as string;
  }

  get appStoreSuffix(): string {
    const os = this.browserParser.getOS();

    if (os.name === 'iOS') {
      return this.$t('common.smartBanner.priceSuffixApple') as string;
    } else if (os.name === 'Android') {
      return this.$t('common.smartBanner.priceSuffixGoogle') as string;
    }

    return this.$t('common.smartBanner.priceSuffixApple') as string;
  }

  get buttonText(): string {
    return this.$t('common.smartBanner.button') as string;
  }

  get appStoreUrl(): string {
    const os = this.browserParser.getOS();

    if (os.name === 'iOS') {
      return 'https://apps.apple.com/us/app/planbook.com/id1502332358';
    } else if (os.name === 'Android') {
      return 'https://play.google.com/store/apps/details?id=com.planbook.lessonplanner';
    }

    // Default to App Store for desktop/other
    return 'https://apps.apple.com/us/app/planbook.com/id1502332358';
  }

  closeBanner(): void {
    // Set cookie to prevent banner from showing again
    Cookies.set(this.cookieName, 'true', {
      expires: this.cookieExpirationDays,
      path: '/'
    });

    // Remove body padding
    document.body.style.paddingTop = '';

    // Hide banner by setting isVisible to false
    this.isVisible = false;
  }
}
